import { request, errHandler, baseUrl } from "./heimdall";
import store from "../store";

export function getServers() {
  return request
    .get(`/servers`, {
      headers: {
        Authorization: store.getters.getToken
      }
    })
    .then(({ data }) => data)
    .catch(errHandler);
}

export function getServer(id) {
  return request
    .get(`/servers/${id}`, {
      headers: {
        Authorization: store.getters.getToken
      }
    })
    .then(({ data }) => data)
    .catch(errHandler);
}

export function getServerInProvider(id) {
  return request
    .get(`/servers/provider/${id}`, {
      headers: {
        Authorization: store.getters.getToken
      }
    })
    .then(({ data }) => data)
    .catch(errHandler);
}

export function createServer(server) {
  return request
    .post(`/servers/create`, server, {
      headers: {
        Authorization: store.getters.getToken
      }
    })
    .then(({ data }) => data)
    .catch(errHandler);
}

export function updateServer(id, data) {
  return request
    .put(`/servers/update/${id}`, data, {
      headers: {
        Authorization: store.getters.getToken
      }
    })
    .then(({ data }) => data)
    .catch(errHandler);
}

export function deleteServer(id) {
  return request
    .delete(`/servers/delete/${id}`, {
      headers: {
        Authorization: store.getters.getToken
      }
    })
    .then(({ data }) => data)
    .catch(errHandler);
}

export function addUser(id, email) {
  return request
    .put(
      `/servers/${id}/user`,
      {
        email: email
      },
      {
        headers: {
          Authorization: store.getters.getToken
        }
      }
    )
    .then(({ data }) => data)
    .catch(errHandler);
}

/**
 * Remove a user from a site,
 * Here we use fetch as a replacement of Axio, because of a delete request with a body
 * @see https://github.com/axios/axios/issues/736
 * @param {Number} id The id of the site from which we need to remove the user
 * @param {String} email The email of the user to remove from the site
 */
export function removeUser(id, email) {
  return fetch(`${baseUrl}/servers/${id}/user`, {
    method: "DELETE",
    headers: {
      "Content-Type": "application/json",
      Authorization: store.getters.getToken
    },
    body: JSON.stringify({
      email: email
    })
  })
    .then(({ data }) => data)
    .catch(errHandler);
}

export function getProviders() {
  return request
    .get(`/providers`, {
      headers: {
        Authorization: store.getters.getToken
      }
    })
    .then(({ data }) => data)
    .catch(errHandler);
}

export function getHealth(id, scale, time) {
  return request
    .get(`/healths/${id}?time=${timeScale[scale] * time}`, {
      headers: {
        Authorization: store.getters.getToken
      }
    })
    .then(({ data }) => data)
    .catch(errHandler);
}

const timeScale = {
  year: 365 * 24 * 60 * 60 * 1000,
  month: 31 * 24 * 60 * 60 * 1000,
  day: 24 * 60 * 60 * 1000,
  hour: 60 * 60 * 1000,
  minute: 60 * 1000,
  second: 1000
};
